import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.25 41.998a3 3 0 0 1-4.023-3.135c.419-3.895 1.237-7.107 2.466-9.636-2.208-1.688-4.548-4.067-7.027-7.14a3 3 0 0 1 1.713-4.819c2.722-.575 5.802-.882 9.242-.921.956-3.447 2.398-6.49 4.329-9.121a3 3 0 0 1 4.841.005c1.933 2.646 3.378 5.687 4.335 9.115 3.489.04 6.585.347 9.291.924a3 3 0 0 1 1.726 4.797c-2.45 3.094-4.81 5.486-7.09 7.178 1.183 2.502 1.991 5.692 2.437 9.574a3 3 0 0 1-4.032 3.152c-3.718-1.39-6.745-2.996-9.08-4.824-2.335 1.85-5.378 3.464-9.127 4.85Z",
      clipRule: "evenodd"
    }
  )
);
var SvgStarFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StarFilled_default = SvgStarFilled;

export { StarFilled_default as default };
